import {createFileRoute} from '@tanstack/react-router'
import RyderCupView from "../../../rydercup/RyderCupView.tsx";

export const Route = createFileRoute('/_app/rydercup/$uid/$page')({
    component: RouteComponent,
})

function RouteComponent() {
    return <RyderCupView />
}
